import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/**
 * Componente que representa una casilla de verificación (checkbox).
 */
@Component({
  selector: 'app-am-check-box',
  templateUrl: './am-check-box.component.html',
  styleUrls: ['./am-check-box.component.scss'],
  standalone: false,
})
export class AmCheckBoxComponent implements OnInit {
  /**
   * Estado actual de la casilla de verificación.
   * Si es `true`, la casilla está marcada; si es `false`, está desmarcada.
   *
   * @type {boolean}
   * @default false
   */
  @Input() check = false;

  /**
   * Estilo agragado para alinear el Check-box
   *
   *
   * @type {boolean}
   * @default false
   */
  @Input() topBox = false;

  /**
   * Indica si la casilla de verificación está deshabilitada.
   * Si es `true`, la casilla no puede ser interactuada.
   *
   * @type {boolean}
   * @default false
   */
  @Input() disabled = false;

  /**
   * EventEmitter que se utiliza para emitir un evento cuando el estado de la casilla cambia.
   * El evento emite el nuevo estado de la casilla (`true` o `false`).
   *
   * @type {EventEmitter<boolean>}
   */
  @Output() handleCheck: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() disabledClick: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}
  /**
   * Método que se ejecuta cuando el usuario interactúa con la casilla de verificación.
   * Cambia el estado de la casilla (marcado/desmarcado) y emite el nuevo estado a través del `EventEmitter`.
   * Este método no realiza ninguna acción si la casilla está deshabilitada.
   *
   * @return {void} No retorna ningún valor.
   */
  onChange() {
    if (!this.disabled) {
      this.check = !this.check;
      this.handleCheck.next(this.check);
    } else {
      this.disabledClick.emit();
    }
  }
}
